// Moved to components/Table/DataTable — nothing here was users-specific.
//
// The users-shaped bits (loginCount, lastSeen, lastCountry, hasAddress,
// eligibleForMagazine) moved to UsersContainer as `formatCell`, which is passed in as the
// shared table's `formatValue`. They render exactly as they did here, ticks included —
// see the note on formatCell for why that is not the same function as the CSV formatter.
//
// The copy here also keyed cells and headers on Math.random(), rebuilding every row on
// every render, and made every header clickable even though two RDL columns are declared
// `sortable: false`. Both stop with the shared table.
export { default } from '../../Table/DataTable';
